var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.433 17.1875C19.9724 17.1875 20.4096 16.7503 20.4096 16.2109V3.90625C20.4096 1.75234 18.6572 0 16.5033 0H4.49707C2.34316 0 0.59082 1.75234 0.59082 3.90625V21.0938C0.59082 23.2477 2.34316 25 4.49707 25H16.5033C18.6573 25 20.4096 23.2477 20.4096 21.0938C20.4096 20.5544 19.9724 20.1172 19.4331 20.1172C18.8937 20.1172 18.4565 20.5544 18.4565 21.0938C18.4565 22.1707 17.5803 23.0469 16.5034 23.0469H4.49707C3.42012 23.0469 2.54395 22.1707 2.54395 21.0938V3.90625C2.54395 2.8293 3.42012 1.95312 4.49707 1.95312H16.5034C17.5803 1.95312 18.4565 2.8293 18.4565 3.90625V16.2109C18.4564 16.7503 18.8937 17.1875 19.433 17.1875Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5264 5.85938H5.46777C4.92842 5.85938 4.49121 6.29658 4.49121 6.83594C4.49121 7.37529 4.92842 7.8125 5.46777 7.8125H15.5264C16.0657 7.8125 16.5029 7.37529 16.5029 6.83594C16.5029 6.29658 16.0657 5.85938 15.5264 5.85938Z",
    fill: "#9C9C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5264 9.76562H5.46777C4.92842 9.76562 4.49121 10.2028 4.49121 10.7422C4.49121 11.2815 4.92842 11.7188 5.46777 11.7188H15.5264C16.0657 11.7188 16.5029 11.2815 16.5029 10.7422C16.5029 10.2028 16.0657 9.76562 15.5264 9.76562Z",
    fill: "#9C9C9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5767 13.6719H5.46777C4.92842 13.6719 4.49121 14.1091 4.49121 14.6484C4.49121 15.1878 4.92842 15.625 5.46777 15.625H11.5768C12.1161 15.625 12.5533 15.1878 12.5533 14.6484C12.5532 14.1091 12.116 13.6719 11.5767 13.6719Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.06123bc156e21954b9af91488941e097.svg";
export { ForwardRef as ReactComponent };